/**
 * アバターパーツセット情報
 */
export interface ApiAvatarPartsSet {
  /**
   * パーツセットID
   */
  id: number
  colorId: AvatarItemColorId
}
/**
 * ガチャ情報
 */
export interface ApiGacha {
  /**
   * ガチャID
   */
  id: number
  /**
   * ガチャ名
   */
  name: string
  /**
   * 表示順優先度
   */
  priority: number
  original: AvatarOriginal
  /**
   * ガチャ残り回数が有効か(falseは無効)
   */
  isUseRemainingTimes: boolean
  /**
   * ガチャ残り回数
   */
  remainingTimes: number
  /**
   * ガチャバナーurl
   */
  bannerUrl: string // uri
  /**
   * ガチャ開始日時
   */
  startAt: string // date-time
  /**
   * ガチャ終了日時
   */
  endAt: string // date-time
  /**
   * ガチャ消費タイプ一覧
   */
  consumeTypes: ApiGachaConsumeType[]
  /**
   * ガチャアイテム一覧
   */
  items: ApiGachaItem[]
  /**
   * ウェルカムセールガチャかどうか
   */
  isWelcomeSale: boolean
}
/**
 * ガチャ消費タイプ
 */
export interface ApiGachaConsumeType {
  type: GachaConsumeType
  /**
   * ガチャ消費名
   */
  name: string
  /**
   * 消費数
   */
  amount: number
  ticketTypeId?: GachaTicketTypeId
}
/**
 * ガチャ実行リクエスト
 */
export interface ApiGachaDrawReq {
  /**
   * 実行するガチャID
   */
  id: number
  type: GachaConsumeType
  /**
   * ガチャの消費量
   */
  amount: number
  /**
   * ガチャで消費するチケット種別ID
   */
  ticketTypeId: number
}
/**
 * ガチャApiレスポンス
 */
export interface ApiGachaDrawResp {
  ok: ApiOk
  payload: ApiGachaDrawRespPayload
}
/**
 * ガチャApiレスポンスpayload
 */
export interface ApiGachaDrawRespPayload {
  gachaResult: ApiGachaResultItem[]
}
/**
 * ガチャアイテム
 */
export interface ApiGachaItem {
  rarity: GachaItemRarity
  /**
   * ガチャアイテムID
   */
  itemId: number
  /**
   * アイテム表示名称
   */
  name: string
  priority: GachaItemPriority
  colorName?: GachaItemColorName
  partsSets: ApiAvatarPartsSet[]
}
/**
 * ガチャアイテム排出率
 */
export interface ApiGachaItemEmissionRate {
  emissionRate: GachaItemEmissionRate // double
  rarity: GachaItemRarity
  /**
   * ガチャアイテムID
   */
  itemId: number
  /**
   * アイテム表示名称
   */
  name: string
  partsSets: ApiGachaItemListAvatarPartsSet[]
}
/**
 * ガチャレアリティ排出率
 */
export interface ApiGachaRarityEmissionRate {
  rarity: number
  emissionRate: GachaItemEmissionRate // double
}
/**
 * アバターパーツセット情報
 */
export interface ApiGachaItemListAvatarPartsSet {
  /**
   * パーツセットID
   */
  id: number
  colorId: AvatarItemColorId
  original: AvatarOriginal
  itemImageUrl: string // アイテム画像URL
}
/**
 * ガチャアイテム排出率一覧Apiレスポンスpayload
 */
export interface ApiGachaItemListPayload {
  /**
   * ガチャアイテム排出率一覧
   */
  gachaItems: ApiGachaItemEmissionRate[]
  rarityRates: ApiGachaRarityEmissionRate[]
}
/**
 * ガチャアイテム排出率一覧Apiリクエスト
 */
export interface ApiGachaItemListReq {
  /**
   * 一覧を取得するガチャID
   */
  gachaId: number
  /**
   * レア度以上確定ウェイトセットID
   */
  rarityGuaranteeWeightSetId?: number
}
/**
 * ガチャアイテム排出率一覧Apiレスポンス
 */
export interface ApiGachaItemListResp {
  ok: ApiOk
  payload: ApiGachaItemListPayload
}

export const ApiGachaListCallFromOdds: string = 'odds'

/**
 * 
 */
export interface ApiGachaListReq {
  /**
   * リクエスト元の指定(WebContentsの場合は排出率一覧からの呼び出しでodds固定)
   */
  from: string
}

/**
 * response
 */
export interface ApiGachaListResp {
  ok: ApiOk
  payload: ApiGachaListRespPayload
}
/**
 * ガチャ一覧api payload
 */
export interface ApiGachaListRespPayload {
  /**
   * ガチャ一覧
   */
  gachaList: ApiGacha[]
}
/**
 * ガチャ結果アイテム情報
 */
export interface ApiGachaResultItem {
  /**
   * ガチャアイテムID
   */
  itemId: number
}
/**
 * Api実行結果
 */
export type ApiOk = boolean
/**
 * ユーザーガチャチケット所持数
 */
export interface ApiUserGachaTicket {
  /**
   * ガチャチケット種別ID
   */
  id: number
  /**
   * ガチャチケット名
   */
  name: string
  /**
   * 所持ガチャチケット枚数
   */
  amount: number
}
/**
 * ガチャチケット所持枚数取得Apiレスポンス
 */
export interface ApiUserGachaTicketGetsResp {
  ok: ApiOk
  payload: ApiUserGachaTicketGetsRespPayload
}
/**
 * ガチャ排出物一覧Apiレスポンスpayload
 */
export interface ApiUserGachaTicketGetsRespPayload {
  userGachaTickets?: ApiUserGachaTicket[]
}
/**
 * ガチャチケット所持数増加リクエストbody
 */
export interface ApiUserGachaTicketIncrementReq {
  id: GachaTicketTypeId
  /**
   * 付与するチケット数
   */
  amount: number
}
/**
 * ガチャチケット所持枚数増加Apiレスポンス
 */
export interface ApiUserGachaTicketIncrementResp {
  ok: ApiOk
}
/**
 * 色情報ID(数字4文字)
 */
export type AvatarItemColorId = string
/**
 * 体型情報(F001,M001など英1文字+数字3文字)
 */
export type AvatarOriginal = string
/**
 * ガチャ消費タイプ(1=コイン,2=ガチャチケット)
 */
export type GachaConsumeType = number
/**
 * カラー表記
 */
export type GachaItemColorName = string
/**
 * ガチャアイテム排出確率（％）
 */
export type GachaItemEmissionRate = number // double
/**
 * 並び順優先度
 */
export type GachaItemPriority = number
/**
 * アイテムレア数
 */
export type GachaItemRarity = number
/**
 * ガチャチケットID
 */
export type GachaTicketTypeId = number
export type RequestBody = ApiUserGachaTicketIncrementReq
export namespace Responses {
  export type $200 = ApiUserGachaTicketIncrementResp
}
